import React from 'react';
import { css } from '@styled-system/css';
import styled from 'styled-components';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const containedStyles = css((theme) => ({
  maxWidth: [
    "100%",
    theme.containers.xs,
    theme.containers.sm,
    theme.containers.ms,
    theme.containers.md,
    theme.containers.ml,
    theme.containers.lg,
    theme.containers.xl,
    theme.containers.xxl
  ]
}));
const sizeVariants = variant({
  prop: "responsiveSize",
  variants: {
    fluid: {
      maxWidth: "100%"
    },
    contained: containedStyles,
    xs: {
      maxWidth: ({ theme }) => theme.containers.xs
    },
    sm: {
      maxWidth: ({ theme }) => theme.containers.sm
    },
    ms: {
      maxWidth: ({ theme }) => theme.containers.ms
    },
    md: {
      maxWidth: ({ theme }) => theme.containers.md
    },
    ml: {
      maxWidth: ({ theme }) => theme.containers.ml
    },
    lg: {
      maxWidth: ({ theme }) => theme.containers.lg
    },
    xl: {
      maxWidth: ({ theme }) => theme.containers.xl
    },
    xxl: {
      maxWidth: ({ theme }) => theme.containers.xxl
    }
  }
});
const StyledContainer = styled(Box)`
    margin-left: auto;
    margin-right: auto;
    width: 100%;

    /* Default padding - mobile first */
    padding-left: ${spacing("sm")};
    padding-right: ${spacing("sm")};
    --maestro-container-padding: ${spacing("sm")};

    ${({ theme }) => theme.breakpoint("ms", "up")`
        padding-left: ${spacing("lg")};
        padding-right: ${spacing("lg")};
        --maestro-container-padding: ${spacing("lg")};
    `};

    ${({ theme }) => theme.breakpoint("lg", "up")`
        padding-left: ${spacing("xl")};
        padding-right: ${spacing("xl")};
        --maestro-container-padding: ${spacing("xl")};
    `};

    ${sizeVariants};
`;
const Container = forwardRef((props, ref) => {
  const _a = props, { size = "xxl" } = _a, rest = __objRest(_a, ["size"]);
  return /* @__PURE__ */ React.createElement(StyledContainer, __spreadValues({
    ref,
    responsiveSize: size
  }, rest));
});
Container.displayName = "Container";

export { Container };
//# sourceMappingURL=Container.es.js.map
